<template lang="html">
  <div class="gift-card">
    <h2 class="mb-4">Information</h2>

    <info-table
      :headers="headers"
      :value="item"
    >
      <template #item.giftcard_number="{value}">
        <code-display :value="value" />
      </template>
    </info-table>

    <v-divider class="my-5" />


    <div class="">
      <h2 class="mb-4">Original Payment</h2>

      <div class="">
        <v-list>
          <v-list-item
            two-line
            link
            @click="openPaymentById(item.originalPayment)"
          >
            <v-list-item-content>
              <v-list-item-title>
                Payment
              </v-list-item-title>
              <v-list-item-subtitle>
                Click to open
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-progress-circular
                v-if="$store.getters.isLoadingFor(`payments_${item.originalPayment}.read`)"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
    </div>

    <v-divider class="my-5" />

    <div class="">
      <h2 class="mb-4">Use Payments</h2>

      <div class="">
        <div v-if="!item.usePayments || item.usePayments.length == 0" class="">
          Gift card has not been used yet
        </div>
        <div v-else>
          <v-list>
            <v-list-item
              two-line
              v-for="usePayment in (item.usePayments || [])" :key="usePayment"
              link
              @click="openPaymentById(usePayment)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  Payment
                </v-list-item-title>
                <v-list-item-subtitle>
                  Click to open
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-progress-circular
                  v-if="$store.getters.isLoadingFor(`payments_${usePayment}.read`)"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </div>

    <v-dialog :value="!!selectedPayment" @input="closePayment" max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          Order details
          <div class="d-inline-block ml-4">
            <div
              v-if="(selectedPayment || {}).transactionType == 'REFUND'"
              class="d-flex flex-row align-center red--text text--darken-1"
            >
              <span>Refund</span>
              <v-icon class="ml-2 red--text text--darken-1">mdi-cash-refund</v-icon>
            </div>
            <div v-else
              class="d-flex flex-row align-center green--text text--darken-1"
            >
              <span>Purchase</span>
              <v-icon class="ml-2 green--text text--darken-1">mdi-basket</v-icon>
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <payment :item="selectedPayment" @open-payment="openPaymentById"/>
        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="closePayment">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import InfoTable from '../components/InfoTable.vue';
import Payment from '../components/Payment.vue';
import CodeDisplay from '../components/CodeDisplay.vue';

export default {
  name: 'GiftCardForm',
  props: {
    item: {}
  },
  data() {
    return {
      headers: [
        {
          text: 'Code',
          value: 'giftcard_number'
        },
        {
          text: 'Current Amount',
          value: 'amount',
          morph: (v) => (v || 0) + ' SEK'
        },
        {
          text: 'Original Amount',
          value: 'originalAmount',
          morph: (v) => (v || 0) + ' SEK'
        },
        {
          text: 'Number of uses',
          value: 'usePayments',
          morph: (v) => (v || []).length + ((v || []).length == 1 ? ' use' : ' uses')
        },
        {
          text: 'Created at',
          value: 'created_at',
          morph: (v) => (v || '').slice(0, 16)
        },
        {
          text: 'Created by',
          value: 'created_by'
        }
      ],
      selectedPayment: null
    };
  },
  methods: {
    openPaymentById (paymentId) {
      var payment = this.$store.getters['payments/getItemById'](paymentId);
      if (payment) {
        // Close previous to visulize change of payment object
        this.selectedPayment = null;
        setTimeout(() => {
          this.selectedPayment = payment;
        }, 250);
        return;
      }
      var promise = this.$store.dispatch('payments/fetchItemById', paymentId).then(() => {
        this.selectedPayment = this.$store.getters['payments/getItemById'](paymentId);
      }, () => {
        this.$snackbar({message: 'Failed to fetch payment', theme: 'error'});
      });
      this.selectedPayment = null;
      return promise;
    },
    closePayment () {
      this.selectedPayment = null;
    }
  },
  components: {
    InfoTable,
    Payment,
    CodeDisplay
  }
}
</script>

<style lang="css" scoped>
</style>
